<div class="content-wrapper">
  <div class="col-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Create Adhoc Request Form</h4>
        <form #ngNewAdhocForm="ngForm" (ngSubmit)="ngNewAdhocForm.form.valid && onSubmit()" novalidate>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="plantName">Plant Name</label>
                <ng-select [(ngModel)]="plantName" name="plantName" required #plantNameRef="ngModel">
                  <ng-option *ngFor="let location of Locations" [value]="location.name">
                    {{ location.name }}
                  </ng-option>
                </ng-select>
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && plantNameRef.invalid">
                  Plant name is required!
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="costCenterId">Cost Center</label>
                <ng-select [(ngModel)]="costCenterId" name="costCentreId" required #costCentreIdRef="ngModel">
                  <ng-option *ngFor="let costCenter of CostCenters" [value]="costCenter.id">
                    {{ costCenter.code }} - {{ costCenter.name }}
                  </ng-option>
                </ng-select>
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && costCentreIdRef.invalid">
                  Cost Center is required!
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="sectionOrDepartment">Function</label>
                <select class="form-control" [(ngModel)]="sectionOrDepartment" name="sectionOrDepartment" required #sectionOrDepartmentRef="ngModel">
                  <option value="">-- Select Function --</option>
                  <option *ngFor="let department of Departments" [value]="department.name">
                    {{ department.name }}
                  </option>
                </select>
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && sectionOrDepartmentRef.invalid">
                  Function is required!
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="numberRequired">Number Required</label>
                <input type="number" class="form-control" [(ngModel)]="numberRequired" name="numberRequired" required min="1" #numberRequiredRef="ngModel">
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && numberRequiredRef.invalid">
                  Please specify a valid number of staff.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="startDate">Expected Start Date</label>
                <input type="date" class="form-control" [(ngModel)]="startDate" name="startDate" required #startDateRef="ngModel">
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && startDateRef.invalid">
                  Start date is required!
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="endDate">Expected End Date</label>
                <input type="date" class="form-control" [(ngModel)]="endDate" name="endDate" required #endDateRef="ngModel">
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && endDateRef.invalid">
                  End date is required!
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="jobDescription">Job Description</label>
                <textarea class="form-control" rows="4" [(ngModel)]="jobDescription" name="jobDescription" required #jobDescriptionRef="ngModel"></textarea>
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && jobDescriptionRef.invalid">
                  Description is required!
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="skillsRequired">Skills Required</label>
                <textarea class="form-control" rows="4" [(ngModel)]="skillsRequired" name="skillsRequired" required #skillsRequiredRef="ngModel"></textarea>
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && skillsRequiredRef.invalid">
                  Skills are required!
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="vendorId">Vendor</label>
                <ng-select [(ngModel)]="vendorId" name="vendorId" required #vendorIdRef="ngModel">
                  <option value="">-- Select Function --</option>
                  <ng-option *ngFor="let vendor of Vendors" [value]="vendor.id">
                    {{ vendor.name }}
                  </ng-option>
                </ng-select>
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && vendorIdRef.invalid">
                  Vendor is required!
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="cost">Cost</label>
                <input type="number" class="form-control" [(ngModel)]="cost" name="cost" required min="0"
                  #costRef="ngModel">
                <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && costRef.invalid">
                  Cost is required and must be 0 or greater.
                </div>
              </div>
            </div>
          </div>

          <hr>

          <div class="col-12">
            <h4 class="card-title">Approvals</h4>
            <table class="table table-bordered">
              <tbody>
                <tr class="table-info">
                  <td>1</td>
                  <td>Line Manager</td>
                  <td>
                    <ng-select [(ngModel)]="lineManagerToApprove" name="lineManagerToApprove" required #lmRef="ngModel">
                      <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                        {{ manager.firstName }} - {{ manager.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && lmRef.invalid">
                      Please provide Line Manager to approve.
                    </div>
                  </td>
                </tr>
                <tr class="table-danger">
                  <td>2</td>
                  <td>Head of Department</td>
                  <td>
                    <ng-select [(ngModel)]="hodToApprove" name="hodToApprove" required #hodRef="ngModel">
                      <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                        {{ manager.firstName }} - {{ manager.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && hodRef.invalid">
                      Please provide HOD to approve.
                    </div>
                  </td>
                </tr>
                <tr class="table-warning">
                  <td>3</td>
                  <td>Plant Controller</td>
                  <td>
                    <ng-select [(ngModel)]="plantControllerToApprove" name="plantControllerToApprove" required #pcRef="ngModel">
                      <ng-option *ngFor="let plant of PlantManagers" [value]="plant.email">
                        {{ plant.firstName }} - {{ plant.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && pcRef.invalid">
                      Please provide Plant Controller to approve.
                    </div>
                  </td>
                </tr>
                <tr class="table-success">
                  <td>4</td>
                  <td>HRBP</td>
                  <td>
                    <ng-select [(ngModel)]="hrbpToApprove" name="hrbpToApprove" required #hrbpRef="ngModel">
                      <ng-option *ngFor="let hrbp of HRBPS" [value]="hrbp.email">
                        {{ hrbp.firstName }} - {{ hrbp.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && hrbpRef.invalid">
                      Please provide HRBP to approve.
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <hr>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button type="button" class="btn btn-light" (click)="onCancel()">Cancel</button>
        </form>
      </div>
    </div>
  </div>
</div>
